module.exports = __webpack_public_path__ + "static/ProjectStructure-ef132aab90d71d12ba6692807cf91a14.png";